import { useMemo, useState } from "react";
import { GALLERY } from "@/lib/site";
import useSEO from "@/hooks/useSEO";

const CATEGORIES = ["All", "Wraps", "Signs", "Window", "Wall", "Installation"];

export default function Gallery() {
  useSEO({
    title: "Gallery · Recent Installations",
    description: "A portfolio of recent sign and architectural wrap installations across Toronto and the GTA — wraps, signage, window film, wall graphics, and vinyl installation projects.",
    path: "/gallery",
  });
  const [filter, setFilter] = useState("All");
  const items = useMemo(() => filter === "All" ? GALLERY : GALLERY.filter(g => g.cat === filter), [filter]);

  return (
    <>
      <section className="pt-36 pb-16 bg-ink-950 border-b border-white/5" data-testid="gallery-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="eyebrow gold-bar">Gallery</div>
          <h1 className="font-display text-5xl md:text-7xl mt-4 tracking-tight">Selected work.</h1>
          <p className="text-white/60 max-w-2xl mt-5">A sample of recent installations across Toronto &amp; the GTA.</p>
        </div>
      </section>

      <section className="py-16 bg-ink-950">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex flex-wrap gap-2 mb-10" data-testid="gallery-filters">
            {CATEGORIES.map(c => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                data-testid={`filter-${c.toLowerCase()}`}
                className={`px-5 py-2 text-[11px] uppercase tracking-[0.2em] border transition-colors ${filter===c ? "bg-gold text-black border-gold" : "border-white/15 text-white/70 hover:border-gold hover:text-gold"}`}
              >{c}</button>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((g, i) => (
              <div key={g.src} className={`group relative overflow-hidden card-dark ${i%5===0 ? "sm:col-span-2" : ""}`} data-testid={`gallery-item-${i}`}>
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={g.src} alt={`${g.title} — ${g.cat} project by Toronto Custom Signs & Wraps`} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-transparent to-transparent opacity-90" />
                <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.25em] text-gold">{g.cat}</div>
                    <div className="font-display text-lg mt-1">{g.title}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
